import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import Grid from '@zenbusiness/zui/Grid';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

// OrderView (main page)
export const Root = superstyled({
  name: 'OrderViewRoot',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    paddingTop: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    [theme.breakpoints.up('md')]: {
      paddingTop: '2rem',
    },
  }),
});

export const OverViewCard = superstyled({
  name: 'OrderViewOverViewCard',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    padding: '1rem',
    borderRadius: theme.shape.borderRadius,
    marginBottom: '1.5rem',
    [theme.breakpoints.up('md')]: {
      padding: '1.5rem 2rem',
    },
  }),
});

export const CompanyDetails = superstyled({
  name: 'OrderViewCompanyDetails',
  slot: 'Root',
  tag: Grid,
  styles: ({ theme }) => ({
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      marginBottom: '2rem',
    },
  }),
});

// Details component
export const DetailsRoot = superstyled({
  name: 'OrderViewDetailsRoot',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    padding: '1rem',
    borderRadius: theme.shape.borderRadius,
    marginBottom: '1.5rem',
    [theme.breakpoints.up('md')]: {
      padding: '1.5rem 2rem',
    },
  }),
});

export const DetailsRow = superstyled({
  name: 'OrderViewDetailsRow',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'grid',
    margin: '1rem 0',
    gridTemplateColumns: '4fr 8fr',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '3fr 7fr',
    },
  }),
});

// BillingInfo component
export const BillingInfoRoot = superstyled({
  name: 'OrderViewBillingInfoRoot',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    padding: '1rem',
    borderRadius: theme.shape.borderRadius,
    marginBottom: '1.5rem',
    [theme.breakpoints.up('md')]: {
      padding: '1.5rem 2rem',
    },
  }),
});

export const OverflowText = superstyled({
  name: 'OrderViewOverflowText',
  slot: 'Root',
  tag: Text,
  styles: () => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
});

// ChargesTable component
export const ChargesTableRoot = superstyled({
  name: 'OrderViewChargesTableRoot',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    padding: '1rem',
    borderRadius: theme.shape.borderRadius,
    marginBottom: '1.5rem',
    [theme.breakpoints.up('md')]: {
      padding: '1.5rem 2rem',
    },
  }),
});

export const OrderRow = superstyled({
  name: 'OrderViewOrderRow',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'grid',
    margin: '1rem 0',
    gridTemplateColumns: '4fr 8fr',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '3fr 7fr',
    },
  }),
});

export const StyledTable = superstyled({
  name: 'OrderViewTable',
  slot: 'Root',
  tag: 'table',
  styles: ({ theme }) => ({
    width: '100%',
    borderCollapse: 'collapse',
    '& thead': {
      border: 'none',
      ...theme.typography?.body_smallBold,
      color: theme.palette.text.secondary,
    },
    '& th': {
      padding: '0.75rem',
      paddingLeft: 0,
      border: 'none',
      textAlign: 'left',
    },
    '& td': {
      padding: '0.75rem',
      paddingLeft: 0,
      border: 'none',
    },
  }),
});

// ChargesRow component
export const ChargesRow = superstyled({
  name: 'OrderViewChargesRow',
  slot: 'Root',
  tag: 'tr',
  styles: ({ theme }) => ({
    marginTop: '0.625rem',
    [theme.breakpoints.up('md')]: {},
  }),
});

export const ChargesDescription = superstyled({
  name: 'OrderViewChargesDescription',
  slot: 'Root',
  tag: Text,
  styles: ({ theme }) => ({
    paddingRight: 0,
    textTransform: 'capitalize',
    [theme.breakpoints.up('md')]: {
      paddingRight: '0.625rem',
    },
  }),
});

// IncludedInPlan component
export const TitleButton = superstyled({
  name: 'OrderViewTitleButton',
  slot: 'Root',
  tag: Text,
  styles: () => ({
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  }),
});

// GetProductDescription component
export const ProductDescriptionRoot = superstyled({
  name: 'OrderViewProductDescriptionRoot',
  slot: 'Root',
  tag: Box,
  styles: () => ({
    display: 'flex',
    gap: '0.5rem',
  }),
});
